/**
 * Circuit propre à un MODÈLE d'arrêté (cas sensibles) — recette du 28/09.
 * Les modèles arrivent par l'import Excel (pas d'écran de modèle) : le réglage vit donc
 * dans Service technique → Réglages, comme les autres. On choisit le modèle, puis on
 * règle SES intervenants ; ceux du circuit par défaut apparaissent « circuit par défaut ».
 */
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { CircuitValidationPanel } from './CircuitValidationPanel';

type Modele = Awaited<ReturnType<typeof api.acteModeles.list>>[number];

export function CircuitParModeleSection() {
  const [modeles, setModeles] = useState<Modele[]>([]);
  const [choisi, setChoisi] = useState('');
  useEffect(() => {
    api.acteModeles.list({ pour: 'service_technique' }).then(setModeles).catch(() => setModeles([]));
  }, []);
  if (!modeles.length) {
    return <p className="text-sm text-ink-muted">Aucun modèle d’arrêté pour l’instant : ils s’importent depuis Administration → Données.</p>;
  }
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <label htmlFor="circuit-modele" className="text-sm text-ink">Modèle d’arrêté</label>
        <select id="circuit-modele" value={choisi} onChange={(e) => setChoisi(e.target.value)}
          className="h-10 min-w-[18rem] rounded-r-lg border border-border bg-surface/60 px-2.5 text-sm text-ink">
          <option value="">Choisir un modèle…</option>
          {modeles.map((m) => <option key={m.id} value={m.id}>{m.libelle}</option>)}
        </select>
      </div>
      {choisi && <CircuitValidationPanel key={choisi} modeleId={choisi} />}
    </div>
  );
}
